import { Box, Typography } from '@mui/material';
import { TournamentTeamsList } from 'modules/tournaments/components/BracketTournament/TournamentTeams/TournamentTeamsList';
import { TournamentSettingsTitle } from 'modules/tournaments/components/TournamentSettingsTitle';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { EmptyPlaceholder } from 'shared/components/EmptyPlaceholder';

export const TournamentTeams: FC = () => {
  const teamsSize = useSelector(currentTournamentSelector.teamsSize);
  const teams = useSelector(currentTournamentSelector.teams);
  const readyTeamsCount = useSelector(currentTournamentSelector.readyTeamsCount);
  const isSinglePlayer = useSelector(currentTournamentSelector.isSinglePlayer);

  if (!teams?.length) {
    return (
      <Box p={3} bgcolor="background.paper">
        <EmptyPlaceholder text="Be the first to join the tournament!" />
      </Box>
    );
  }

  return (
    <Box p={3} bgcolor="background.paper">
      <Box display="flex">
        <TournamentSettingsTitle>{isSinglePlayer ? 'Players' : 'Teams'}</TournamentSettingsTitle>
        <Typography variant="subtitle1" color="text.disabled" ml={1}>
          {`(${readyTeamsCount}/${teams?.length} ready)`}
        </Typography>
      </Box>
      <TournamentTeamsList teams={teams} teamsSize={teamsSize} />
    </Box>
  );
};
